// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3fHnP","vLegacy":"SelectSecondary_vLegacy__3hDqw","error":"SelectSecondary_error__382yQ","disabled":"SelectSecondary_disabled__3lnk8"};